import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {Document} from '../model/continent';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private httpClient: HttpClient) {}

  private document: BehaviorSubject<Document> = new BehaviorSubject<Document>(new Document({
    type: 'VOUCHER',
    hotels: [],
    departures: [],
    transits: [],
    arrivals: [],
    transfers: [],
    active: true,
    version: 0
  }));
  private currentIndex: number = 0;
  documents: Document[] = [];


  getDocumentsList(params: PaginationParams): Observable<Pagination<Document>> {
    const cleanParams = cleaningParams(params);
    return this.httpClient.get<Pagination<Document>>(`${environment.apiUrl}/document`,
      { params: { ...cleanParams } });
  }

  getDocumentStream(id: number, templateName: string): any {
    return this.httpClient.get(`${environment.apiUrl}/document/stream/${templateName}/${id}`, { responseType: 'blob' });
  }


  getDocument(id: number): Observable<Document> {
    return this.httpClient.get<Document>(`${environment.apiUrl}/document/${id}`);
  }

  saveDocument(Document: Document): Observable<Document> {
    return this.httpClient.post<Document>(`${environment.apiUrl}/document`, Document);
  }


  deleteDocument(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/document/${id}`);
  }


}
